import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LockedList } from './non-adherence-list';
import { NonAdherenceListService } from './non-adherence-list.service';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';

@Component({
  selector: 'app-non-adherence-list',
  templateUrl: './non-adherence-list.component.html',
  styleUrls: ['./non-adherence-list.component.css']
})
export class NonAdherenceListComponent implements OnInit {
  @SessionStorage() public user;
  public timesheetLock: LockedList[] = [];
  public selectedCheckbox: Array<any> = [];
  public totalElements = 0;
  public pageNumber = 1;
  constructor(
    private nonAdherenceListService: NonAdherenceListService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.getLockedList();
  }

  /**function to get locked list */
  getLockedList() {
    this.timesheetLock = [];
    this.nonAdherenceListService.getLockedList(this.pageNumber).subscribe((response) => {
      this.totalElements = response.payload.LockedCount;
      response.payload.lockedEmplist.filter(ele => ele.editMode === true).map(value => {
        this.timesheetLock.push(new LockedList(value));
      });
      if (response.payload.lockedEmplist) {
        response.payload.lockedEmplist.filter(ele => ele.lockedDetails.isLocked === true).map(ele => {
          this.timesheetLock.push(new LockedList(ele));
        });
      }
    });
  }

  /**function to unlock selected employee */
  unlockSelected(empId) {
    const employees = [];
    employees.push(empId);
    if (employees.length > 0) { // if Atleast 1 request is selected
      this.nonAdherenceListService.unLockTimeSheet(employees).subscribe((response) => {
        this.snackBar.open('Unlocked selected employees Successfully', 'OK', {
          duration: 3000,
        });
        this.getLockedList();
      }, (error) => {
        this.snackBar.open('Error occured while unlocking the timesheet', 'OK', {
          duration: 3000
        });
      });
    }
  }

  /* Upon change of pagination call API again */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getLockedList();
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/non-adherence-list/non-adherence-list.component.ts